import React, { lazy, useEffect,  useRef,  useState } from 'react';
import { MediaAttachment } from 'src/shared/types/src';
import MediaTypeDisplay from '../mediaCollage/MediaTypeDisplayComponent';
import Slider from "react-slick";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import CustomButton from '../CustomButton';


const MediaCarouselContainer = ({ media }: { media: MediaAttachment[] }) => {

    const sliderRef: any = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    
    const settings = {
        arrows: true,
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: true,
        beforeChange: (_current: any, next: number) => {
            
            const sliderElement = sliderRef?.current?.innerSlider?.list;
            const videos = sliderElement.querySelectorAll("video");

            videos.forEach((video: { paused: any; pause: () => void; }, index: number) => {
              if (index !== next && !video.paused) {
                video.pause();
              }
            });
            setCurrentSlide(next)
        },
        nextArrow: <CustomButton icon={<FaChevronRight size={20} color='#fff' />} color='link'onClick={() => { }} customBtnStyle={`slick-arrow slick-next ${currentSlide === media.length - 1 ? 'disabled' : ''}`} />,
        prevArrow: <CustomButton icon={<FaChevronLeft size={20} color='#fff'  />} color='link'onClick={() => { }} customBtnStyle={`slick-arrow slick-prev ${currentSlide === 0 ? 'disabled' : ''}`} />,
    };

    const _renderItem = (item: MediaAttachment, index: number) => {
        return (

            <MediaTypeDisplay media={item} collageDisplay={false} key={index}  />
        );
    }

    return (
        <>
            <div className='media-modal-carousel'>
                {
                    media.length > 1 ?
                    <Slider {...settings} ref={sliderRef}>
                        {media.map((item, index) => _renderItem(item, index))}
                    </Slider>
                    : 
                    <div className='w-100 h-100 media-img'>
                        {media.map((item, index) => _renderItem(item, index))}
                    </div>
                }
            </div>

        </>

    )
}

export default MediaCarouselContainer;
